module.exports = __webpack_public_path__ + "img/partner_channel2.0b9b2daa.png";